import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-button',
  standalone: true,
  imports: [MatButtonModule],
  template: `
    <div class="formly-field-button-container">
      <button
        mat-raised-button
        color="primary"
        [type]="props.type || 'button'"
        [disabled]="props.disabled"
        (click)="props.onClick(field, $event)">
        {{ props.text }}
      </button>
    </div>
  `,
  styles: [`
    .formly-field-button-container {
      display: flex;
      justify-content: flex-end;
    }
  `],
})
export class FormlyFieldButton extends FieldType<FieldTypeConfig> {
  onClick(){
  }
}
